import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

function Services() {

  const { t } = useTranslation();

  return (
    <div className="services">
      <section>
        <p>
          <Trans i18nKey="text.app.intro">
            The <span className="normal-weight">DSPLAY Token Generator</span> allows you to show your data from external applications/services to the screens powered by <a href="https://dsplay.tv">DSPLAY - Digital Signage</a>.
          </Trans>
        </p>
        <p>
          {t('Please select the application/service you want to integrate with')}:
          <ul>
            <li><Link to="/facebook">Facebook</Link></li>
            <li><Link to="/instagram">Instagram</Link></li>
          </ul>
        </p>
      </section>
    </div>
  );
}

export default Services;